import React from 'react';
import { Calendar } from 'lucide-react';
export function ActionButton() {
  return <div className="w-full space-y-4" data-id="element-148">
      <a href="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#06b6d4] to-[#0891b2] hover:from-[#0891b2] hover:to-[#0e7490] text-white font-bold py-4 px-8 rounded-lg text-xl transition-all transform hover:scale-105 shadow-lg hover:shadow-xl" data-id="element-149">
        ¡Obtén Acceso Ahora!
      </a>

      <div className="flex items-center gap-4" data-id="element-150">
        <div className="flex-1 h-px bg-gray-300" data-id="element-151"></div>
        <span className="text-gray-500 font-medium text-sm uppercase" data-id="element-152">o</span>
        <div className="flex-1 h-px bg-gray-300" data-id="element-153"></div>
      </div>

      <a href="https://api.leadconnectorhq.com/widget/bookings/info-commerce-llamada-de-claridad-crea-tu-producto-digital-con-ia" target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center gap-2 bg-white border-2 border-[#06b6d4] text-[#06b6d4] hover:bg-[#06b6d4] hover:text-white font-bold py-4 px-8 rounded-lg text-xl transition-all transform hover:scale-105 shadow-lg hover:shadow-xl" data-id="element-154">
        <Calendar className="w-5 h-5" data-id="element-155" />
        Agenda una Llamada con Mi Equipo
      </a>
    </div>;
}